/**
 * Created by Ivan on 17.10.2024
 */

const OpenLetterButtonBooster = BaseButtonBooster.extend({
    ctor: function (booster, sceneComponent) {
        this.booster = booster;

        this.shadow = new ShadowLayer();
        this.shadow.setLocalZOrder(OpenLetterButtonBooster.SHADOW_Z);

        this.keypadView = sceneComponent.keypadView;
        this.boardView = sceneComponent.boardView;
        this.hintButton = sceneComponent.hintButton;

        this._super({
            booster,
            styles: cleverapps.styles.OpenLetterButtonBooster
        });

        booster.on("afterExecute", this.createListener(this.afterExecute.bind(this)), this);
    },

    createIcon: function () {
        return new cc.Sprite(bundles.buttons.frames.open_letter_png);
    },

    runMagnifierBoardAnimation: function () {
        const styles = cleverapps.styles.OpenLetterButtonBooster.magnifier;
        const grid = this.boardView.grid;

        this.idleState = false;

        this.removeCloseButton();

        this.magnifier.stopAllActions();

        this.magnifier.replaceParentSamePlace(grid);
        const startPosition = this.magnifier.positionFromAlignment(styles.start);
        const finishPosition = this.magnifier.positionFromAlignment(styles.finish);

        const movingNode = cleverapps.Scenes.GetMovingNode();
        this.magnifier.replaceParentSamePlace(movingNode);
        const position1 = movingNode.convertToNodeSpace(grid.convertToWorldSpace(startPosition));
        const position2 = movingNode.convertToNodeSpace(grid.convertToWorldSpace(finishPosition));

        this.magnifier.runAction(new cc.Sequence(
            new cc.MoveTo(0.5, position1.x, position1.y),
            new cc.MoveTo(0.8, position2.x, position2.y),
            new cc.RemoveSelf()
        ));
    },

    addMagnifier: function () {
        const magnifier = this.magnifier = new cleverapps.Spine(bundles.game.jsons.open_letter_magnifer_json);
        this.magnifier.avoidNode = "MagnifierAnimation";
        magnifier.setAnimation(0, "keypad", true);
        magnifier.setAnchorPoint(0.25, 0.75);
        this.keypadView.addChild(magnifier);

        const startLetter = this.keypadView.letters[0];
        const startPosition = cc.p(startLetter.x, startLetter.y);
        magnifier.setAlignment(startPosition);
    },

    addCloseButton: function () {
        const styles = cleverapps.styles.OpenLetterButtonBooster.button;

        const button = this.closeButton = new cleverapps.UI.Button({
            type: cleverapps.styles.UI.Button.Images.button_green,
            onClicked: function () {},
            text: Messages.get("Cancel"),
            width: styles.width,
            height: styles.height
        });
        button.setVisible(false);

        this.keypadView.addChild(button);
        button.setAlignment(styles.position);
    },

    runMagnifierKeypadAnimation: function () {
        const styles = cleverapps.styles.OpenLetterButtonBooster.magnifier;

        this.addMagnifier();
        this.addCloseButton();

        let idlePosition = this.magnifier.positionFromAlignment(styles.idlePosition);

        const movingNode = cleverapps.Scenes.GetMovingNode();
        this.magnifier.replaceParentSamePlace(movingNode, { keepScale: true });

        const endLetter = this.keypadView.letters[1];
        const endPosition = movingNode.convertToNodeSpace(this.keypadView.convertToWorldSpace(cc.p(endLetter.x, endLetter.y)));

        const keypadCenter = this.keypadView.convertToWorldSpace(cc.p(this.keypadView.width / 2, this.keypadView.height / 2));
        const centerPoint = movingNode.convertToNodeSpace(keypadCenter);
        const rotateAngle = 2 * Math.PI - Math.atan2(endPosition.y - centerPoint.y, endPosition.x - centerPoint.x);

        idlePosition = movingNode.convertToNodeSpace(this.keypadView.convertToWorldSpace(idlePosition));

        this.magnifier.runAction(new cc.Sequence(
            new cc.Spawn(
                new cc.MoveInArc(1, centerPoint, rotateAngle).easing(cc.easeOut(1.1)),
                new cc.RotateBy(1, -60)
            ),
            new cc.Spawn(
                new cc.MoveTo(0.75, idlePosition.x, idlePosition.y).easing(cc.easeBackOut()),
                new cc.RotateBy(0.75, 60).easing(cc.easeBackIn())
            ),
            new cc.ReplaceParent(this.keypadView),
            new cc.CallFunc(() => {
                this.magnifier.setAnimation(0, "idle", true);
            })
        ));

        this.closeButton.runAction(new cc.Sequence(
            new cc.DelayTime(1.5),
            StandartAnimations.showUp(this.closeButton),
            new cc.CallFunc(() => {
                this.idleState = true;
                this.onResize();
                cleverapps.scenes.onAvoidNodeVisibilityChanged();
            })
        ));
    },

    onResize: function () {
        if (!this.idleState) {
            return;
        }

        const styles = cleverapps.styles.OpenLetterButtonBooster;
        if (this.magnifier) {
            this.magnifier.setAlignment(styles.magnifier.idlePosition);
        }

        if (this.closeButton) {
            this.closeButton.setAlignment(styles.button.position);
        }
    },

    removeMagnifierAnimation: function () {
        this.idleState = false;
        this.magnifier.stopAllActions();
        this.magnifier.runAction(new cc.Sequence(
            StandartAnimations.disappear(this.magnifier),
            new cc.CallFunc(() => {
                this.magnifier.clearTrack(0);
            }),
            new cc.RemoveSelf(),
            new cc.CallFunc(() => {
                this.magnifier = undefined;
            })
        ));

        this.removeCloseButton();
    },

    removeCloseButton: function () {
        this.closeButton.runAction(new cc.Sequence(
            StandartAnimations.disappear(this.closeButton),
            new cc.RemoveSelf(),
            new cc.CallFunc(() => {
                this.closeButton = undefined;
            })
        ));
    },

    onExecute: function () {
        if (!cleverapps.forces.isRunningForce()) {
            this.shadow.createShadow();
            this.moveUp();
        }

        this.runMagnifierKeypadAnimation();

        this.clickHandler = cleverapps.pointerManager.create(this.shadow, {
            swallowEvents: true,
            onOuterTouch: function () {
                if (!cleverapps.forces.isRunningForce()) {
                    this.booster.cancel();
                }
            }.bind(this)
        });
    },

    afterExecute: function (cancel) {
        if (!cleverapps.forces.isRunningForce()) {
            this.shadow.deleteShadow();
            this.moveDown();
        }

        this.clickHandler.remove();

        if (!cancel) {
            this.runMagnifierBoardAnimation();
        } else {
            this.removeMagnifierAnimation();
        }

        this.keypadView.letters.forEach((letter) => {
            letter.enable();

            if (letter.animation) {
                letter.animation.removeFromParent();
            }

            if (letter.hoverHandler) {
                letter.hoverHandler.remove();
            }
        });

        this.keypadView.shuffleButton.show();
    },

    moveUp: function () {
        [this.boardView, this.hintButton, this.parent, this.keypadView].forEach((element, index) => {
            element.oldZ = element.getLocalZOrder();
            element.setLocalZOrder(OpenLetterButtonBooster.SHADOW_Z + index + 1);
        });
    },

    moveDown: function () {
        [this.boardView, this.hintButton, this.parent, this.keypadView].forEach((element) => {
            element.setLocalZOrder(element.oldZ);
            delete element.oldZ;
        });
    }
});

OpenLetterButtonBooster.SHADOW_Z = 11;

cleverapps.styles.OpenLetterButtonBooster = {
    width: 150,
    height: 120,

    position: [
        { x: { align: "left", dx: 15 }, y: { align: "bottom", dy: 350 } },
        { x: { align: "right", dx: -10 }, y: { align: "bottom", dy: 465 } },
        { x: { align: "right", dx: -10 }, y: { align: "bottom", dy: 465 } }
    ],
    scale: [0.9, 1, 1],
    content: {
        margin: -5,
        direction: cleverapps.UI.VERTICAL,
        layout: { x: { align: "center", dx: 0 }, y: { align: "center", dy: 20 } },
        freeBlock: { textWidth: 120 }
    },

    button: {
        position: [
            { x: { align: "center", dx: -295 }, y: { align: "top", dy: 15 } },
            { x: { align: "center", dx: 400 }, y: { align: "center", dy: 0 } },
            { x: { align: "center", dx: 400 }, y: { align: "center", dy: 0 } }
        ],
        width: 200,
        height: 80
    },

    magnifier: {
        start: { x: { align: "left", dx: -100 }, y: { align: "center" } },
        finish: { x: { align: "right", dx: 100 }, y: { align: "center" } },
        idlePosition: [
            { x: { align: "center", dx: 200 }, y: { align: "center", dy: 310 } },
            { x: { align: "center", dx: 400 }, y: { align: "center", dy: 200 } },
            { x: { align: "center", dx: 400 }, y: { align: "center", dy: 200 } }
        ]
    }
};